import { NewsTeaserParams, getTeasersFromApi } from 'application/repositories/teaserRepository';

export const getTeasersSorted = async (params: NewsTeaserParams): Promise<Models.TeaserArticle[]> => {
	return getTeasersFromApi(params);
};
